import { render, staticRenderFns } from "./ref-code.vue?vue&type=template&id=e352aa60"
import script from "./ref-code.vue?vue&type=script&lang=js"
export * from "./ref-code.vue?vue&type=script&lang=js"
import style0 from "./ref-code.vue?vue&type=style&index=0&id=e352aa60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports